"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _findIndex = _interopRequireDefault(require("./findIndex"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function removeAsset(a, b) {
  if (!a) return a;
  var c = a.slice();
  return c.splice((0, _findIndex["default"])(c, b), 1), c;
}

var _default = removeAsset;
exports["default"] = _default;